// extracted by mini-css-extract-plugin
export default {"root":"xrzATvgKq4JpTZ7S_X9j","active":"YkxTKc4oUJHQbChvqf5Y","deleted":"iP05ywJzd4jmUOUJW_mS","inactive":"Tc9mESLf4UBN0zYPlYQP","placeHolderShimmer":"dJgui5VT6Y072eSMlMhT"};